const MAX_LOOPS = 48;

/**
 * Creates an array of month-year options for the calendar.
 * For example:
 * [
 *   {
 *     formatted: 'January 2025',
 *     date: new Date('2025-01-01'),
 *     isSelected: true,
 *   },
 *   {
 *     formatted: 'February 2025',
 *     date: new Date('2025-02-01'),
 *     isSelected: false,
 *   },
 * ]
 */
export default function createOptions(
  minDate: Date,
  maxDate: Date,
  locale: string = 'en',
) {
  const monthOptions = [];
  const currentDate = minDate;

  let maxReached = false;
  let index = 0;

  while (!maxReached) {
    const monthOptionDate = new Date(minDate);
    monthOptionDate.setMonth(currentDate.getMonth() + index, 1);

    monthOptions.push({
      formatted: new Intl.DateTimeFormat(locale, { month: 'long', year: 'numeric' }).format(monthOptionDate),
      date: monthOptionDate,
    });

    index += 1;

    // Fail-safe to prevent infinite or long running loops
    if (index >= MAX_LOOPS) {
      maxReached = true;
    }

    if (monthOptionDate.getTime() > maxDate.getTime()) {
      maxReached = true;
    }
  }

  return monthOptions;
}
